import React from 'react';
import PropTypes from 'prop-types';
import { CardHeader as MuiCardHeader, withStyles } from '@material-ui/core';

const styles = {
  cardAction: {
    marginTop: 0,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  cardHeader: {
    backgroundColor: '#f9f9f9',
    padding: '5px 15px',
    height: '45px',
  },
};

const CardHeader = ({ classes, ...props }) => (
  <MuiCardHeader
    style={styles.cardHeader}
    titleTypographyProps={{ variant: 'h6', style: { lineHeight: '18px' } }}
    classes={{
      action: classes.cardAction,
    }}
    {...props}
  />
);

CardHeader.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardHeader);
